import {
  FETCH_START,
  FETCH_RESET,
  HIDE_MESSAGE,
  SHOW_MESSAGE,
  CHANGE_LOADING_STATE,
  CLEAR_IS_USER_CHECK
} from 'src/constants/ActionTypes';

/**
 * fetchStart: Request API
 *
 * @param {*} urlData
 * @param {*} method
 * @param {*} value
 * @param {*} apiType
 * @param {*} getName
 * @returns
 */
export const fetchStart = (configAPI, getName = '', cbSuccess, cbError) => ({
  type: FETCH_START,
  configAPI,
  getName,
  cbSuccess,
  cbError
});

export const showMessage = (message) => ({
  type: SHOW_MESSAGE,
  payload: message
});

export const hideMessage = () => ({
  type: HIDE_MESSAGE
});

export const fetchReset = (getName) => ({
  type: FETCH_RESET,
  getName
});

export const changeLoadingState = (value) => ({
  type: CHANGE_LOADING_STATE,
  payload: { loading: value }
});

export const clearIsUserCheck = () => ({
  type: CLEAR_IS_USER_CHECK
});
